import validatePackageTemplateChooser, {
  PackageTemplateChooserErrors,
} from '~/pages/common/PackageTemplateChooser/validate';
import { SavePackageTemplateFormValues } from './SavePackageTemplateModal';

export interface SavePackageTemplateErrors extends PackageTemplateChooserErrors {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parcelTemplateName?: Maybe<any>;
}

const validate = (values: SavePackageTemplateFormValues) => {
  const errors = validatePackageTemplateChooser(values) as SavePackageTemplateErrors;

  if (values.parcelTemplateName && values.parcelTemplateName.length > 50) {
    errors.parcelTemplateName = 'The package template name cannot be longer than 50 characters.';
  }

  if (values.extras && values.extras.isUsingCustomDimensions && !values.parcelTemplateName) {
    errors.parcelTemplateName = 'Please enter a package name';
  }

  return errors;
};

export default validate;
